import { Box } from '@mui/material'
import { styled } from '@mui/system'

export const Root = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    minHeight: '100vh'
}))

export const ContentContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    width: '100%',
    margin: 'auto 0',
    gap: theme.spacing(3)
}))
